 // Social and External link warning Fixed
document.addEventListener("DOMContentLoaded", function () {
  const currentHost = window.location.hostname.replace('www.', '');
  const warningText = " Redirecting to a third-party website,opens in a new tab.";

  const links = document.querySelectorAll('a[href^="http://"], a[href^="https://"]');

  links.forEach(function (link) {
    const linkHost = link.hostname.replace('www.', '');

    if (linkHost === currentHost || !linkHost) return;

    let linkText = link.textContent.trim();

    if (!linkText) {
      const img = link.querySelector('img');
      const imgAlt = img ? img.getAttribute('alt') : null;
      linkText = imgAlt ? imgAlt.trim() : "this link";
    }

    const currentAriaLabel = link.getAttribute('aria-label');

    const newLabel = currentAriaLabel
      ? `${currentAriaLabel}${warningText}`
      : `${linkText}${warningText}`;

    link.setAttribute('aria-label', newLabel);
    link.setAttribute('title', newLabel);
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer nofollow');

    link.classList.add('external-link');
  });
});

// add aria-hidden="true" on all br tags

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('br').forEach(function (br) {
    br.setAttribute('aria-hidden', 'true');
  });
});

//th broken aria-label issue fix "aria-labelled by removed

window.addEventListener('load', function () {
  document.querySelectorAll('[aria-labelledby]').forEach(function (el) {
    const refId = el.getAttribute('aria-labelledby');

    if (!document.getElementById(refId)) {
      el.removeAttribute('aria-labelledby');
    }
  });
});
///back to top
document.addEventListener('DOMContentLoaded', function () {
  var backToTopButton = document.getElementById('back-to-top');
  window.onscroll = function () {
    if (window.pageYOffset > 300) {
      backToTopButton.style.display = 'block';
    } else {
      backToTopButton.style.display = 'none';
    }
  };
  backToTopButton.onclick = function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.setTimeout(function () {
      document.getElementById('backtoheader').focus();
    }, 600);
  };
});

// header
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.header__menu details').forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;
    function updateExpanded() {
      summary.setAttribute(
        'aria-expanded',
        details.hasAttribute('open') ? 'true' : 'false'
      );
    }
    // Set initial state
    updateExpanded();
    // Watch for changes to the "open" attribute
    new MutationObserver(updateExpanded).observe(details, {
      attributes: true,
      attributeFilter: ['open']
    });
  });
});
// escape on header
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  const openDetails = document.querySelector(
    '.header__menu details[open]'
  );

  if (!openDetails) return;

  const summary = openDetails.querySelector(':scope > summary');

  if (!summary) return;

  event.preventDefault();

  openDetails.removeAttribute('open');
  summary.setAttribute('aria-expanded', 'false');

  requestAnimationFrame(function () {
    summary.focus();
  });
});

//  Slider on homepage 
document.querySelectorAll('.swiper-initialized').forEach(function (swiperEl) {
  const wrapper = swiperEl.querySelector('.swiper-wrapper');
  if (!wrapper) return;

  const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));

  // Get the number of visible slides based on the current viewport
  function getItemsPerView() {
    const width = window.innerWidth;

    if (width < 768) {
      return 1; // Mobile
    } else if (width < 1024) {
      return parseInt(swiperEl.getAttribute('data-tablet-items'), 10) || 1;
    }

    return parseInt(swiperEl.getAttribute('data-items'), 10) || 1;
  }

  // Update aria-hidden and tabindex for visible/hidden slides
  function updateAriaHidden() {
    const itemsPerView = getItemsPerView();

    const activeSlide = slides.find(function (slide) {
      return slide.classList.contains('swiper-slide-active');
    });

    if (!activeSlide) return;

    const activeIndex = parseInt(
      activeSlide.getAttribute('data-swiper-slide-index'),
      10
    );

    slides.forEach(function (slide) {
      const slideIndex = parseInt(
        slide.getAttribute('data-swiper-slide-index'),
        10
      );

      // Slides currently visible in the viewport
      const isVisible =
        slideIndex >= activeIndex &&
        slideIndex < activeIndex + itemsPerView;

      slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

      // Remove hidden slides from keyboard navigation
      slide
        .querySelectorAll('a, button, input, select, textarea, [tabindex]')
        .forEach(function (element) {
          element.setAttribute('tabindex', isVisible ? '0' : '-1');
        });
    });
  }

  // Initial update
  updateAriaHidden();

  // Observe slide class changes (active/inactive)
  const observer = new MutationObserver(function (mutations) {
    const shouldUpdate = mutations.some(function (mutation) {
      return mutation.attributeName === 'class';
    });

    if (shouldUpdate) {
      updateAriaHidden();
    }
  });

  slides.forEach(function (slide) {
    observer.observe(slide, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  // Update on window resize
  window.addEventListener('resize', updateAriaHidden);
});

// Filters on collection pahe collapsed and. expanded btn
document.addEventListener('DOMContentLoaded', function () {
  function initFacetAccordionAccessibility() {
    document.querySelectorAll('#FacetDrawer details').forEach(function (details) {
      const trigger = details.querySelector(':scope > summary');

      if (!trigger) return;

      trigger.setAttribute('role', 'button');

      function updateAccordionState() {
        trigger.setAttribute(
          'aria-expanded',
          details.hasAttribute('open') ? 'true' : 'false'
        );
      }

      updateAccordionState();

      if (!details._facetAccordionObserver) {
        details._facetAccordionObserver = new MutationObserver(function () {
          updateAccordionState();
        });

        details._facetAccordionObserver.observe(details, {
          attributes: true,
          attributeFilter: ['open']
        });
      }
    });

    document.querySelectorAll('#FacetDrawer button').forEach(function (button) {
      const isAccordionTrigger =
        button.closest('details') &&
        button.matches('summary');

      if (!isAccordionTrigger) {
        button.removeAttribute('aria-expanded');
      }
    });
  }

  initFacetAccordionAccessibility();

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    const openDetails = document.querySelector(
      '#FacetDrawer details[open]'
    );

    if (!openDetails) return;

    const trigger = openDetails.querySelector(':scope > summary');

    if (!trigger) return;

    event.preventDefault();

    openDetails.removeAttribute('open');
    trigger.setAttribute('aria-expanded', 'false');

    requestAnimationFrame(function () {
      trigger.focus();
    });
  });

  const facetDrawer = document.getElementById('FacetDrawer');

  if (facetDrawer) {
    const drawerObserver = new MutationObserver(function () {
      initFacetAccordionAccessibility();
    });

    drawerObserver.observe(facetDrawer, {
      childList: true,
      subtree: true
    });
  }
}); 
// 
document.addEventListener('DOMContentLoaded', function () {
  function initEmailPhoneLabels() {
    document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]').forEach(function (link) {
      if (link.hasAttribute('aria-label')) return;

      const href = link.getAttribute('href') || '';
      const text = link.textContent.trim();

      if (href.startsWith('mailto:')) {
        const email = href.replace(/^mailto:/i, '').split('?')[0].trim();

        if (email) {
          link.setAttribute(
            'aria-label',
            'Email ' + (text || email)
          );
        }
      }

      if (href.startsWith('tel:')) {
        const phone = href.replace(/^tel:/i, '').trim();

        if (phone) {
          link.setAttribute(
            'aria-label',
            'Call ' + (text || phone)
          );
        }
      }
    });
  }

  initEmailPhoneLabels();

  const observer = new MutationObserver(function () {
    initEmailPhoneLabels();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// 
document.addEventListener('DOMContentLoaded', function () {
  function setupAnnouncementAccessibility() {
    var announcementBar = document.querySelector('announcement-bar');
    if (!announcementBar) return;

    announcementBar.setAttribute('role', 'region');
    announcementBar.setAttribute('aria-label', 'Announcement');

    var swiper = announcementBar.swiper;

    if (!swiper) {
      setTimeout(setupAnnouncementAccessibility, 100);
      return;
    }

    function updateAnnouncementAccessibility() {
      var slides = announcementBar.querySelectorAll('.swiper-slide');

      slides.forEach(function (slide) {
        var link = slide.querySelector('.announcement-bar__content');
        var isActive = slide.classList.contains('swiper-slide-active');

        if (isActive) {
          slide.setAttribute('aria-hidden', 'false');
          slide.setAttribute('tabindex', '0');

          if (link) {
            link.removeAttribute('aria-hidden');
            link.removeAttribute('tabindex');
          }
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');

          if (link) {
            link.setAttribute('tabindex', '-1');
          }
        }
      });

      announcementBar.setAttribute('role', 'region');
      announcementBar.setAttribute('aria-label', 'Announcement');
    }

    updateAnnouncementAccessibility();

    swiper.on('slideChange', function () {
      updateAnnouncementAccessibility();
    });

    swiper.on('transitionEnd', function () {
      updateAnnouncementAccessibility();
    });

    swiper.on('slideChangeTransitionEnd', function () {
      updateAnnouncementAccessibility();
    });
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('announcement-bar').then(function () {
      setupAnnouncementAccessibility();
    });
  } else {
    setupAnnouncementAccessibility();
  }
});

function updateSwiperAccessibility(swiper) {
  const slides = swiper.querySelectorAll('.swiper-slide');
  const swiperRect = swiper.getBoundingClientRect();

  slides.forEach(function(slide) {
    const slideRect = slide.getBoundingClientRect();

    // Check whether the slide is actually visible inside the swiper viewport
    const isVisible =
      slideRect.right > swiperRect.left &&
      slideRect.left < swiperRect.right &&
      slideRect.bottom > swiperRect.top &&
      slideRect.top < swiperRect.bottom;

    const focusableElements = slide.querySelectorAll(
      'a, button, input, select, textarea, [tabindex]'
    );

    if (isVisible) {
      slide.removeAttribute('aria-hidden');

      focusableElements.forEach(function(element) {
        if (element.hasAttribute('data-a11y-original-tabindex')) {
          const originalTabindex = element.getAttribute(
            'data-a11y-original-tabindex'
          );

          if (originalTabindex === '') {
            element.removeAttribute('tabindex');
          } else {
            element.setAttribute('tabindex', originalTabindex);
          }

          element.removeAttribute('data-a11y-original-tabindex');
        }
      });

    } else {
      slide.setAttribute('aria-hidden', 'true');

      focusableElements.forEach(function(element) {
        if (!element.hasAttribute('data-a11y-original-tabindex')) {
          element.setAttribute(
            'data-a11y-original-tabindex',
            element.getAttribute('tabindex') || ''
          );
        }

        element.setAttribute('tabindex', '-1');
      });
    }
  });
}


function initSwiperAccessibility() {
  document.querySelectorAll('.swiper').forEach(function(swiper) {

    let updateScheduled = false;

    function scheduleUpdate() {
      if (updateScheduled) return;

      updateScheduled = true;

      requestAnimationFrame(function() {
        updateSwiperAccessibility(swiper);
        updateScheduled = false;
      });
    }

    // Initial update
    scheduleUpdate();

    // Swiper changes classes and transform styles when sliding
    const observer = new MutationObserver(scheduleUpdate);

    observer.observe(swiper, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    // Also update after transitions
    swiper.addEventListener('transitionend', scheduleUpdate);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSwiperAccessibility);
} else {
  initSwiperAccessibility();
}

window.addEventListener('resize', function() {
  document.querySelectorAll('.swiper').forEach(function(swiper) {
    updateSwiperAccessibility(swiper);
  });
});